import { Label as RALabel } from "react-aria-components";
import { tv } from "tailwind-variants";

const selectLabel = tv({
  base: "text-sm text-text-tertiary",
});

interface SelectLabelProps {
  readonly label?: string;
  readonly isRequired?: boolean;
  readonly className?: string;
}

export function SelectLabel({
  label,
  isRequired,
  className,
}: SelectLabelProps) {
  if (!label) return null;
  return (
    <RALabel className={selectLabel({ className })}>
      {label}
      {isRequired && <span className="text-danger ml-0.5">*</span>}
    </RALabel>
  );
}
